/* globals $ */

'use strict';

if (!window.jQuery && !window.$) {
    window.jQuery = require('jquery');
    window.$ = window.jQuery;
}

$(document).ready(function () {
    require('./webshop_components/eventMail').init();
});
